define([
	"dojo/_base/declare",
	"csi/locale",
	"csi/service/nodeService",
	"csi/action/Controller",
], function(declare,locale,{resolveNodesWithDependencies},Controller) {

	return declare(null, {

		/**
	     * @override
	     * gets sourceNode to be able to set "Factory" attribute 
	     */
		async process() {
			const fd = this.m_formData;
			const factory = locale.resource("Factory");
			if (fd.getField(factory) != null) {
				const sources = fd.getFieldValue(factory, true) || fd.getFieldValue("Supplier", true);
				await resolveNodesWithDependencies(sources, ["Child:Factory"], this.m_cache);
			}
			Controller.prototype.process.call(this);
		}
	});
});